import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import './plugins/utils.js'
import './plugins/vant.js'
import 'vant/lib/index.css'
import './mock.js'
import PageFooter from './components/PageFooter.vue'
import NavBar from './components/NavBar.vue'

// 导入全局样式表
import './assets/css/global.css'

// 导入浏览器标题兼容组件
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

Vue.component('page-footer', PageFooter)
Vue.component('nav-bar', NavBar)

Vue.prototype.$http = axios

Vue.config.productionTip = false

Vue.filter('getDate', function(value) {
  // 返回处理后的值
  var date = new Date(value * 1000)
  var Y = date.getFullYear() + '-'
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
  var h = (date.getHours() + '').padStart(2, 0) + ':'
  var m = (date.getMinutes() + '').padStart(2, 0) + ':'
  var s = (date.getSeconds() + '').padStart(2, 0)
  return Y + M + D + h + m + s
})

function initRem() {
  // 最大宽度是540,最大比例是540/375
  var cale = window.window.screen.availWidth / 375
  if (window.window.screen.availWidth > 540) {
    window.document.documentElement.style.fontSize = (540 / 375) * 100 + 'px'
  } else {
    window.document.documentElement.style.fontSize = `${100 * cale}px`
  }
  // var cale = window.screen.availWidth > 540 ? 1 : window.screen.availWidth / 375
  // window.document.documentElement.style.fontSize = `${100 * cale}px`
}
initRem()
window.addEventListener('resize', function() {
  initRem()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
